import { useEffect, useState } from "react"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Loader } from "@/components/ui/loader"
import { Switch } from "@/components/ui/switch"
import {
    getCandidateQuestionnaireResponses,
    patchCandidateQuestionnaireResponses
} from "@/api/candidate/candidateQuestionnaireResponses"
import {BackButton} from "@/components/ui/BackButton.jsx";

export default function QuestionnaireForm() {
    const [questions, setQuestions] = useState([])
    const [responses, setResponses] = useState({})
    const [loading, setLoading] = useState(true)
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        async function load() {
            try {
                const data = await getCandidateQuestionnaireResponses()
                setQuestions(data)
                setResponses(
                    Object.fromEntries(
                        data.map((q) => [q.id, q.candidateQuestionnaireResponse?.answerText || ""])
                    )
                )
            } catch (err) {
                console.error("Failed to load questionnaire", err)
            } finally {
                setLoading(false)
            }
        }
        load()
    }, [])


    const handleChange = (id, value) => {
        setResponses((prev) => ({ ...prev, [id]: value }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSaving(true)
        const payload = Object.entries(responses).map(([questionId, answerText]) => ({
            questionnaire_question_id: parseInt(questionId, 10),
            answer_text: answerText
        }))
        try {
            console.log(payload)
            await patchCandidateQuestionnaireResponses({answers:payload})
        } catch (err) {
            console.error("Failed to save responses", err)
            alert("Failed to save. Please try again.")
        } finally {
            setSaving(false)
        }
    }

    if (loading) return <Loader />

    const isVisible = (question) => {
        if (!question.reliesOnId) return true
        return responses[question.reliesOnId] === "Yes"
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-6 p-3 bg-brand-25">
            <BackButton to="/profile/candidate" />
            {questions.map((q) => {
                if (!isVisible(q)) return null

                return (
                    <div key={q.id} className="space-y-2">
                        <Label className="block font-medium text-base">{q.questionText}</Label>

                        {q.questionType === "bool" ? (
                            <div className="flex items-center gap-2">
                                <Switch
                                    checked={responses[q.id] === "Yes"}
                                    onCheckedChange={(checked) =>
                                        handleChange(q.id, checked ? "Yes" : "No")
                                    }
                                    className={" data-[state=checked]:bg-brand-500"}
                                />
                                <span className="text-sm text-muted-foreground">
                  {responses[q.id] === "Yes" ? "Yes" : "No"}
                </span>
                            </div>
                        ) : (
                            <Input
                                type="text"
                                className="bg-white"
                                value={responses[q.id] || ""}
                                onChange={(e) => handleChange(q.id, e.target.value)}
                            />
                        )}
                    </div>
                )
            })}

            <Button type="submit" disabled={saving}>
                {saving ? "Saving..." : "Save"}
            </Button>
        </form>
    )
}
